import axios from 'axios';
import { request, parseError } from '../../helpers/requests';

const AbWorkReportingService = {
  findRevisionDifference: (payload) => request({
    call: axios.post('/abWorkReporting/findRevisionDifference', payload),
    errMsg: parseError('Failed to check revision difference'),
    hideSuccessToast: true,
  }),
  import: (payload) => request({
    call: axios.post('/abWorkReporting/import', payload),
    errMsg: parseError('Failed to import AB work reporting'),
  }),
  getMapping: () => request({
    call: axios.get('/abWorkReporting/mapping'),
    errMsg: parseError('Failed to get AB work reporting mapping'),
    hideSuccessToast: true,
  }),
  saveMapping: (payload) => request({
    call: axios.post('/abWorkReporting/mapping', payload),
    errMsg: parseError('Failed to save AB work reporting mapping'),
  }),
  getWorkReportEntries: (cardId) => {
    const url = cardId ? `/abWorkReporting/workReportEntries/${cardId}` : '/abWorkReporting/workReportEntries';
    return request({
      call: axios.get(url),
      errMsg: 'Could not get AB work reporting entries',
      hideSuccessToast: true,
    });
  },
  createWorkReportEntries: (entries) => request({
    call: axios.post('/abWorkReporting/workReportEntries', entries),
    errMsg: 'Could not create AB work reporting entries',
  }),
  getWorkReportEntryBatches: () => request({
    call: axios.get('/abWorkReporting/workReportEntryBatches'),
    errMsg: 'Could not get AB work reporting entry batches',
    hideSuccessToast: true,
  }),
  batchWorkReportEntries: (payload) => request({
    call: axios.post('/abWorkReporting/batchWorkReportEntries', payload),
    errMsg: 'Could not batch AB work reporting entries',
  }),
  getLatestNumbers: () => request({
    call: axios.get('/abWorkReporting/latestNumbers'),
    errMsg: 'Could not get latest AB work reporting numbers',
    hideSuccessToast: true,
  }),
  updateWorkReportEntry: (id, payload) => request({
    call: axios.put(`/abWorkReporting/updateABWorkReportEntry/${id}`, payload),
    errMsg: 'Could not update AB work report entry',
  }),
  acceptRejectWorksheets: (payload) => request({
    call: axios.post('/abWorkReporting/acceptRejectWorksheets', payload),
    errMsg: 'Could not accept or reject AB work reporting worksheets',
  }),
  getSavedABWorkReportFilters: () => request({
    call: axios.get('/abWorkReporting/filters'),
    errMsg: parseError('Failed to get saved AB work report filters'),
    hideSuccessToast: true,
  }),
  createSavedABWorkReportFilter: (payload) => request({
    call: axios.post('/abWorkReporting/filters', payload),
    errMsg: parseError('Failed to create saved AB work report filter'),
  }),
  updateSavedABWorkReportFilter: (id, payload) => request({
    call: axios.put(`/abWorkReporting/filters/${id}`, payload),
    errMsg: parseError('Failed to update saved AB work report filter'),
  }),
  deleteSavedABWorkReportFilter: (id) => request({
    call: axios.delete(`/abWorkReporting/filters/${id}`),
    errMsg: parseError('Failed to delete saved AB work report filter'),
  }),
  setFavoriteABWorkReportFilter: (id, isFavorite) => request({
    call: axios.put(`/abWorkReporting/filters/${id}/favorite`, { isFavorite }),
    errMsg: parseError('Failed to update saved AB work report filter'),
    hideSuccessToast: true,
  }),
  getDisplayFields: () => request({
    call: axios.get('/abWorkReporting/displayFields'),
    errMsg: parseError('Failed to get AB work report display fields'),
    hideSuccessToast: true,
  }),
  saveDisplayFields: (payload) => request({
    call: axios.post('/abWorkReporting/displayFields', payload),
    errMsg: parseError('Failed to save AB work report display fields'),
  }),
  getJobCodes: () => request({
    call: axios.get('/abWorkReporting/jobCodes'),
    errMsg: parseError('Failed to get AB work reporting job codes'),
    hideSuccessToast: true,
  }),
  createJobCode: (payload) => request({
    call: axios.post('/abWorkReporting/jobCodes', payload),
    errMsg: parseError('Failed to create AB work reporting job code'),
  }),
  updateJobCode: (name, payload) => request({
    call: axios.put(`/abWorkReporting/jobCodes/${encodeURIComponent(name)}`, payload),
    errMsg: parseError('Failed to update AB work reporting job code'),
  }),
  deleteJobCode: (name) => request({
    call: axios.delete(`/abWorkReporting/jobCodes/${encodeURIComponent(name)}`),
    errMsg: parseError('Failed to delete AB work reporting job code'),
  }),
};

export default AbWorkReportingService;